import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import '@fontsource-variable/inter'
import '@fontsource/playfair-display/700.css'

createRoot(document.getElementById("root")!).render(<App />);
